import { selectOverlay } from "@org-avp/avp-avengers-ui-shared-store";
import { viewRegistry } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, useMemo } from "react";
import { useSelector } from "react-redux";
import styles from "./OverlayOutlet.module.less";

export const OverlayOutlet: FC = () => {
  const displayName = useSelector(selectOverlay);
  const overlayViews = useMemo(
    () => viewRegistry.getViews({ type: "fullSize", overlay: true }),
    [],
  );
  const activeFullSizeView = useMemo(
    () => overlayViews.get(displayName ?? ""),
    [displayName, overlayViews],
  );

  return (
    <div className={styles.overlay}>
      {activeFullSizeView?.viewEl}
    </div>
  );
};
